import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

export const crearRetiro = async ({entidad, usuario, idBolsillo, nombreBolsillo}) => {


    let doxConse = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
    let conse = doxConse.data

    let deposito = {
        ...entidad,
        estado: 'Nuevo',
        idUsuario: usuario.id,
        nombres: usuario.nombres,
        apellidos: usuario.apellidos,
        celular: usuario.celular,
        correo: usuario.correo,
        cc: usuario.cc,
        consecutivo: conse,
        tipo: 'Retiro',
        idBolsillo: idBolsillo,
        nombreBolsillo: nombreBolsillo,
        valor: parseInt(entidad.valor),
       // mes: entidad.mes,
        tipoTransaccion:'Transferencia',

    }

    let dox = await guardarDoc('movimientos', deposito)
    if (dox.res) {
        await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: conse})
        return dox
    } else {
        return dox
    }


}